import styled from 'styled-components'
import { alertStyles, AlertStyleType } from '../../styles/common'

export const AlertBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  z-index: 9;
  top: 0;
  background-color: ${(props: any) =>
    alertStyles[props.subtype as keyof AlertStyleType]?.backgroundColor || 'var(--status-info-bg)'};
  color: ${(props: any) =>
    alertStyles[props.subtype as keyof AlertStyleType]?.color || 'var(--status-info-text)'};
  padding: 0.7rem;
  font-weight: 500;

  span {
    color: ${(props: any) => alertStyles[props.subtype as keyof AlertStyleType]?.color}; //#eb5c37;
    cursor: pointer;
    float: right;
    margin-left: 0.8rem;

    &:hover {
      background-color: ${(props: any) =>
        alertStyles[props.subtype as keyof AlertStyleType]?.hoverBackgroundColor}; //#f8cebf;
    }
  }

  a {
    color: ${(props: any) => alertStyles[props.subtype as keyof AlertStyleType]?.color}; //#e94d25;
    font-weight: bold;
    text-decoration: underline;
  }
`

export const TextWrapper = styled.div`
  flex: 1;
  text-align: center;
`
